// @flow
import $ from 'jquery';
import 'fg-frontend/plugins/required/jquery.cookies-policy';

/**
 * JS oznámení o použití cookies na webu
 * default nastavení - viz: fg-frontend/plugins/required/jquery.cookies-policy
 *
 * * možnost redefinovat si styly přidáním parametru přes parametr css, případně je barvu tlačítka a odkazu: css.brandColor
 * * position - určuje vložení do požadovaného elementu na začátek (position: 'top') nebo na konec (position: 'bottom'),
 * * možnost definovat si vlastní textaci přes parametr messages.lang: (defaulty jsou v CS, SK, EN, DE, RU, ES)
 */
export default (): void => {
	$('body').cookiesPolicy({
		lang: window.projectConfig.lang,
    position: 'bottom',
		css: {
			brandColor: '#fd8a00',
			panel: {
        'position': 'fixed',
				'color': '#ffffff',
				'background-color': '#14141B',
				'font-size': '14px',
				'line-height': '22px'
			}
		}
	});
};



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/CookiesPolicy.js